module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_vestfold_telemark_pos.166cc79b.pdf";